@if(data.verified) {
  <h2 mat-dialog-title>Account verified</h2>
  <mat-dialog-content class="mat-typography">
    <p>Your account is verified and ready to use.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close] cdkFocusInitial>OK</button>
  </mat-dialog-actions>
} @else {
  <h2 mat-dialog-title>Account verification required</h2>
  <mat-dialog-content class="mat-typography">
    <p>Unfortunately, we could not verify your account.</p>
    @if(message===1) {
      <p>In order to verify your account we have send 2 micro-deposits. Please check your bank account and press the button VERIFY</p>
      <p>Please be patient while receiving the deposits. It can take up to 3 days.</p>
    }
    @if(message===2) {
      <p class="bold">{{data.messageError}}</p>
      @if(data.messageError === 'Too many confirmation attempts.') {
        <p>We have send 2 new micro-deposits to your account. Please check your bank account and repeat this process.</p>
        <p>Please be patient while receiving the deposits. It can take up to 3 days.</p>
      } @else {
        <p>Please try again.</p>
      }
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close] cdkFocusInitial>OK</button>
  </mat-dialog-actions>
}

